<main id="main" class="main">


  <section class="section dashboard">

    <div class="row">

      <form class="plansform">
        <div class="row">
          <div class="form-group col-12 col-md-12 d-flex justify-content-between"
            style="background: #142a49!important; font-size:14px">
            <h6 class="admintitle">
              {{lang.Members}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
            </h6>
            <!-- add member -->
            <!-- <button (click)="openModelAddMumber()" class="addgroupadmininfoemp">+&nbsp;{{lang.Add_New}}</button> -->
          </div>

          <!-- <div class="row mt-2" [ngStyle]="{'display': showfilter? 'block':'block' }">
            <div class="row filterByStatus mt-1" >
              <div class="col-12 col-md-6 ">
                <label for="" style="font-size: 14px;font-family:'sans-serif' ;">{{lang.Filter_by_Status??'Filter by Status'}}:&nbsp;</label>
              </div>
              <div class="col-md-6 p-0">
                <select name="" id="" class="form-select form-select-sm" (change)="changeStatus($event)">
                  <option value="all">{{lang.All??'All'}}</option>
                  <option *ngFor="let status of filterStatus" [value]="status">{{status}}</option>

                </select>
              </div>
            </div>
          </div> -->

          <!-- <div class="row mt-0 px-0">
            <div style="display: flex; justify-content: space-between;" class="w-100 mb-0 mx-0 p-0">
              <div class="mt-2 mx-4">
                <span>Show</span>
                  <select [(ngModel)]="itemsPerPage" class="mx-1" [ngModelOptions]="{standalone: true}">
                      <option value="{{10}}">10</option>
                      <option value="{{25}}">25</option>
                      <option value="{{50}}">50</option>
                      <option value="{{100}}">100</option>
                  </select>
                  <span>entries</span>
              </div>
              <input class="form-control" style="width: auto;" placeholder="Search here..." [(ngModel)]="filterValue" [ngModelOptions]="{standalone: true}" />
            </div>
          </div> -->

          <!-- <div style="display: flex; justify-content: space-between;" class="w-100 mb-1">
            <div class="mt-2 mx-1">
              <span>Show</span>
                <select [(ngModel)]="itemsPerPage" class="mx-1" [ngModelOptions]="{standalone: true}">
                    <option value="{{10}}">10</option>
                    <option value="{{25}}">25</option>
                    <option value="{{50}}">50</option>
                    <option value="{{100}}">100</option>
                </select>
                <span>entries</span>
            </div>
            <input class="form-control" style="width: auto;" placeholder="Search here..." [(ngModel)]="filterValue" [ngModelOptions]="{standalone: true}" />
          </div> -->


          <div class="table-responsive mt-2">
            <table datatable [dtOptions]="dtOptions" id="DataTables_Table_0" [dtTrigger]="dtTrigger"
            style="margin-top:35px;"
              class="table text-nowrap">
              <!-- <table
                class="table text-nowrap"> -->
              <thead>
                <tr>
                  <th></th>
                  <th>{{lang.IGBMS_Id??'IGBMS Id'}}</th>
                  <th>{{lang.Type??'Type'}}</th>
                  <th>{{lang.Name??'Name'}}</th>
                  <th>{{lang.Email??'Email'}}</th>
                  <th>{{lang.Phone??'Phone'}}</th>
                  <th>{{lang.Registration_Date??'Registration Date'}}</th>
                  <th>{{lang.Status??'Status'}}</th>
                  <th></th>
                  <!-- <th></th> -->

                  <!-- <th></th>
                    <th (click)="sortTable('fusebillCustomerId')" class="sorting">
                      {{lang.IGBMS_Id ?? 'IGBMS Id'}}
                      <i *ngIf="sortColumn === 'fusebillCustomerId'"
                          [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
                          class="ms-2"></i>
                    </th>
                    <th (click)="sortTable('isCorporateAccount')" class="sorting">
                      {{lang.Type ?? 'Type'}}
                      <i *ngIf="sortColumn === 'isCorporateAccount'"
                          [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
                          class="ms-2"></i>
                    </th>
                    <th (click)="sortTable('firstName')" class="sorting">
                      {{lang.Name ?? 'Name'}}
                      <i *ngIf="sortColumn == 'firstName' || sortColumn==''"
                          [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
                          class="ms-2"></i>
                    </th>
                    <th (click)="sortTable('username')" class="sorting">
                      {{lang.Email ?? 'Email'}}
                      <i *ngIf="sortColumn === 'username'"
                          [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
                          class="ms-2"></i>
                    </th>
                    <th (click)="sortTable('primaryPhone')" class="sorting">
                      {{lang.Phone ?? 'Phone'}}
                      <i *ngIf="sortColumn === 'primaryPhone'"
                          [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
                          class="ms-2"></i>
                    </th>
                    <th (click)="sortTable('registrationDate')" class="sorting">
                      {{lang.Registration_Date ?? 'Registration Date'}}
                      <i *ngIf="sortColumn === 'registrationDate'"
                          [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
                          class="ms-2"></i>
                    </th>
                    <th (click)="sortTable('status')" class="sorting">
                      {{lang.Status ?? 'Status'}}
                      <i *ngIf="sortColumn === 'status'"
                          [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
                          class="ms-2"></i>
                    </th>
                    <th></th> -->
                </tr>
              </thead>

              <!-- <tbody> -->
              <tbody *ngIf="!restLoader; else loadingState">
                <tr *ngFor="let client of members; let i = index">
                  <!-- <tr *ngFor="let client of filteredAndPaginatedMembers; let i = index"> -->
                  <td class="my-auto">
                    <i *ngIf="client?.bulkPlanIncluded" class=""
                      style="font-size:14px;color:rgb(31, 31, 29);font-family: system-ui;font-weight: 600;"
                      title="Bulk/Group Plan Member">B</i>
                    <i *ngIf="client?.greenshieldMemberId || client?.greenshieldRegistrationStatus"
                      style="font-size:14px;color:green;font-family: system-ui;font-weight: 600;"
                      title="Greenshield Member">G</i>
                    <i *ngIf="client?.equitableCertificateId || client?.equitableRegistrationStatus"
                      style="font-size:14px;color:#2762b9;font-family: system-ui;font-weight: 600;"
                      title="Equitable Member">E</i>
                  </td>

                  <td>{{client?.fusebillCustomerId}}</td>

                  <td>{{client?.isCorporateAccount?'CORP':'GIG'}}</td>

                  <td (click)="showDetails(client)" style="cursor: pointer;"><span class="viewCorporate"
                      data-bs-target="#memberdetails" data-bs-toggle="modal">{{client?.firstName | titlecase}}
                      {{client?.lastName |titlecase}}</span></td>
                  <td>{{client?.username??''}}</td>
                  <!-- <td>{{client?.user?.username??''}}</td> -->


                  <ng-template [ngIf]="client?.primaryPhone==undefined" [ngIfElse]="contactInformations">
                    <td></td>
                  </ng-template>
                  <ng-template #contactInformations>
                    <td>{{client?.primaryPhone??''}}</td>
                  </ng-template>
                  <!-- <ng-template [ngIf]="client?.contactInformations?.[0]?.primaryPhone==undefiend" [ngIfElse]="contactInformations">
                      <td></td>
                    </ng-template>
                    <ng-template #contactInformations>
                      <td>{{client?.contactInformations?.[0]?.primaryPhone??''}}</td>
                    </ng-template> -->

                  <ng-template [ngIf]="client?.registrationDate?.includes('00-00')??true" [ngIfElse]="registrationDate">
                    <td></td>
                  </ng-template>
                  <ng-template #registrationDate>
                    <td> {{client?.registrationDate | date: 'MM/dd/yyyy' }}</td>
                  </ng-template>
                  <td>
                    <span class="brokertablestatus mx-1 text-center"
                      *ngIf="((client.status != 'Active') && (client?.terminationDate!=null && client?.terminationReason !=null));else normalstatus">Terminated
                    </span>
                    &nbsp;<span style="margin-left:-21px">
                      <!-- <i class="fa fa-info-circle" id="tooltip" style="cursor: pointer;"
                        *ngIf="(client?.terminationDate!=null && client?.terminationReason !=null)">
                        <table class="tooltiptext ignoreTable">
                          <tbody>
                            <tr class="ignoreTable">
                              <td>Date:{{client?.terminationDate | date}}</td>
 
                            </tr>
                            <tr class="ignoreTable">
                              <td>Reason:{{client?.terminationReason}}</td>
 
                            </tr>
 
                          </tbody>
                        </table>
                      </i> -->

                      <!-- Reinstate -->
                        <!-- <i *ngIf="((client.status != 'Active') && (client?.terminationDate!=null && client?.terminationReason !=null))"
                      style="cursor: pointer;font-size:14px;color:green;font-family: system-ui;font-weight: 600;" (click)="handleGetPlansForReinstate(client)"
                      title="Reinstate Member" data-bs-target="#showReinstate" data-bs-toggle="modal">R</i> -->
                    </span>
                    <ng-template #normalstatus>
                      <span class="brokertablestatus mx-1 text-center">{{client?.status}}</span>
                    </ng-template>
 
                  </td>
                  <!-- <td>
                    <button 
                      class="btn btn-primary" 
                      data-bs-toggle="modal"
                      data-bs-target="#activity-log"
                    >
                      View Activity
                    </button>
                  </td> -->

                  <td class="d-flex justify-content-end">
                    <div *ngIf="!client?.isCorporateAccount && role==='ADMINISTRATOR'">
                      <span class="brokertablestatus mx-1 text-center" style="cursor:pointer"
                        (click)="gigtoCorp(client)">Convert to Corp</span>

                    </div>
                    <div style="min-width: 20px;" data-bs-target="showmemberlist">
                      <a *ngIf="(client?.status=='Active' || client?.status=='Draft') && (role==='ADMINISTRATOR' || role==='BROKER')"
                        class="viewicon" title="{{lang?.Terminate}}" data-toggle="tooltip" style="cursor: pointer;"><i
                          class="fa fa-trash-o pe-1" style="color:red; font-size:15px"
                          (click)="terminatemember(client,i)"></i></a>&nbsp;
                    </div>



                    <div style="min-width: 20px;">
                      <a class="viewicon"
                        *ngIf="(client?.status == 'Active' || client?.status == 'Hold')  && client?.bulkPlanIncluded!=true"
                        title="{{lang?.Send_Invite}}" data-toggle="tooltip">
                        <i class="fa fa-send-o cursor: pointer;" style="color:rgb(56,76,159);cursor: pointer;"
                          (click)="invitationMail(client)">
                        </i></a>&nbsp;
                    </div>

                  </td>
                </tr>
                <!-- <tr *ngIf="filteredAndPaginatedMembers.length==0">
                  <td [colSpan]="9" class="text-center">No Data Available</td>
                </tr> -->
              </tbody>

              <ng-template #loadingState>
                <tr *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" class="loader">
                  <td *ngFor="let j of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
                    <div class="is-loading">
                      <p></p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </table>

          </div>

          <!-- <div class="pagination mb-5">
              <span class="mx-2"></span>
              <button class="btn btn-primary" (click)="previousPage()" [disabled]="currentPage === 1">Previous</button>
              <span>Page {{currentPage}} of {{totalPages()}}</span>
              <button class="btn btn-primary" (click)="nextPage()" [disabled]="currentPage === totalPages()">Next</button>
            </div> -->

        </div>

      </form>

      <div class="row">
        <div class=" text-white text-left">
          <!-- <button class="btn btn-primary" id="backbuttonForm"
          type="button" (click)="gotoplansorwalletInfo()" style="float:left"><i aria-hidden="true" class="fa fa-long-arrow-left" ></i>&nbsp;&nbsp;Previous</button> -->

        </div>
        <div class=" text-white text-right">
          <!-- <button class="btn btn-primary" id="basicformSubmit" type="button" (click)="submitEmployeeInfoInfo()"> Save</button> -->
        </div>
      </div>



    </div>
  </section>
</main>


<div class="modal" id="showmemberlist" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <span
          class="modal-title">{{lang.Terminate}}&nbsp;&nbsp;<b>{{emplomentFirstName}}&nbsp;{{emplomentLastName}}</b></span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="model-body">
        <form class="onbordingform" [formGroup]="terminationform">
          <div class="row">
            <div class="col-12 col-md-7">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Please_choose_Termination_Date}}</label>
                <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field"
                  formControlName="terminationDate" [minDate]="minDate" bsDatepicker
                  value="{{ terminationDateValue | date: 'MM-dd-YYYY'}}"
                  [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" [(bsValue)]="terminationDateValue"
                  [(ngModel)]="terminationDateValue" />
                <div class="help-block text-danger" *ngIf="terminationform.get('terminationDate')?.touched ">
                  <div *ngIf="terminationform.get('terminationDate')?.hasError('required') ||
                  (terminationform.get('terminationDate')?.hasError('required'))"> {{lang.Please_Select_Date}}</div>

                </div>
              </div>


              <p *ngIf="role==='ADMINISTRATOR'" style="font-size:10px">{{lang.Plan_enrollment_date_is}}-{{enroll
                |date:'MM-dd-YYYY'}}<br>{{note}}
              </p>

            </div>
          </div>
        </form>

      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="closeTerminatePopup('showmemberlist')">
          {{lang.Close}}
        </button>
        <button class="text-end" type="submit" class="btn btn-primary personalinfobutton" (click)="submittermination()">
          {{lang.Submit}}&nbsp;&nbsp;
        </button>

      </div>
    </div>
  </div>
</div>

  <div class="modal fade" data-bs-backdrop="static" id="showReinstate" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content" id="dependent-content">
        <!-- Modal content for the first modal -->
        <div class="modal-header">
          <h6 class="modal-title">View Reinstate details</h6>
          <div class="col-1 text-end ms-2 ms-md-2">
            <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
              data-bs-dismiss="modal"></i>
          </div>
        </div>
        <div class="modal-body" style="overflow-x: hidden;" *ngIf="reinstateData">
            <b>Customer Details</b>

            <div style="display: flex; width: 100%; height: auto;">
                <div style="width: 40%;">
                  <div style="display: flex; gap:10px;">
                    <p style="width: 114px;">IGBMS Id: </p>
                    <p>{{reinstateData?.customer?.id}}</p>
                </div>

                 <div style="display: flex; gap:10px;">
                    <p>Customer Type: </p>
                    <p>{{reinstateData?.customer?.isCorporateAccount ? "Corporate Employee" : "GIG"}}</p>
                </div>
                </div>
                <div style="width: 60%;">
                  <div style="display: flex; gap:10px;">
                    <p style="width: 150px;">Terminated on: </p>
                    <p>{{modifiedDate(reinstateData?.customer?.terminationDate)}}</p>
                </div>

                <div style="display: flex; gap:10px;">
                    <p style="width: 168px;">Termination Reason: </p>
                    <p>{{ reinstateData?.customer?.terminationReason }}</p>
                </div>
                </div>
            </div>


            <div *ngIf="reinstatePlans" style="margin-top: 20px; width: 100%; overflow-x: auto; margin-bottom: 30px;" >
              <div style="min-width: 800px;">

              <b>Cancelled Plans</b>

                <table id="table"  style="border-collapse: collapse; width: max-content; min-width: 100%;"  class="beneficiaryTable">
            <thead>
              <tr>
                <th rowspan="2" class="text-center">Id</th>
                <th class="text-center">Plan Name</th>
                <th class="text-center">Status</th>
                <th class="text-center">Price</th>
                <th class="text-center">Tax</th>
                <th class="text-center">Payment platform</th>
              </tr>
            </thead>
            <tbody *ngIf="reinstatePlans?.length > 0">
              <tr *ngFor="let data of reinstatePlans; let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td class="text-center" >{{ data.customerPlanProducts[0].product.name }}  {{ checkCoverage(data?.customerPlanProducts[0]?.planCoverage) ??'' }}</td>
                <td class="text-center">{{ data.status }}</td>
                <td class="text-center">${{ data.price }}</td>
                <td class="text-center">${{ data.taxPrice }}</td>
                <td class="text-center">{{ data.paymentPlatform }}</td>
              </tr>
              <!-- <tr>
                <td class="text-center"><b>Grand total</b></td>
                <td style="text-align: right;" colspan="8">${{totalSummaryPrice}}</td>
              </tr> -->
              <tr></tr>
            </tbody>
            <tbody *ngIf="reinstatePlans?.length == 0">
              No Plans to show
            </tbody>
          </table>
        </div>  

                
            </div>


         
              

        </div>
        <div class="modal-footer py-2">
           <div style="display: flex; gap:10px;">
             <div>
               <select  class="form-select border border-dark" id="effectiveDate" placeholder="Select"
               [(ngModel)]="finalEffectiveDate" (change)="handleEffectiveDateChange()">
               <option value="null" label="" selected disabled>Select Effective date</option>
               <option *ngFor="let name of planEnrollmentDates" [value]="name" [label]="name">
                 {{ name }}
                </option>
              </select>
            </div>
            <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel (click)="closeModelPopup('showReinstate')">Close</button>
            <button class="btn btn-primary" type="button" (click)="submitreinstate()"> Reinstate</button>
          </div>
        </div>
      </div>
    </div>
  </div>

<div class="modal" id="showTerminateMemberDetails" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered " id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">

      <div class="modal-header" id="backgroundColor">
        <span
          class="modal-title py-2">{{lang.Terminate}}&nbsp;&nbsp;<b>{{emplomentFirstName}}&nbsp;{{emplomentLastName}}</b></span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="model-body" style="font-family: sans-serif;">
        <form class="onbordingform" [formGroup]="terminationformDetails">

          <div>

            <div class="row ">
              <div class="col-md-6 pt-2">
                <label>{{lang.Customer_Type}}: {{terminateMemberDetails?.customerType }}</label>
              </div>
              <div class="col-md-6 pt-2">
                <label>{{lang.IGBMS_Id}}: {{terminateMemberDetails?.staxbillDetails?.id }}</label>
              </div>
              <div class="col-md-6 pt-2">
                <label>{{lang.Plan_Enrollment_Date}}: {{ terminateMemberDetails?.enrollmentDate}}</label>
              </div>
              <div class="col-md-6 pt-2">
                <label>{{lang.Termination_Date}}: {{terminateMemberDetails?.terminationDate}}</label>
              </div>
              <div class="col-md-6 pt-2">
                <label>{{lang.Service_Type}}:
                  {{terminateMemberDetails?.servicesType.length<=0 ? 'N/A' :
                    terminateMemberDetails?.servicesType?.join(', ') | titlecase}}</label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang.Monthly_Premium}}:
                    {{terminateMemberDetails?.monthlyRecurringAmount==0?"$0":"$"+terminateMemberDetails?.monthlyRecurringAmount}}</label>
                </div>

              </div>
              <div class="row pt-2">

                <div class="col-md-12">
                  <label>{{lang.Refund_Details}}
                  </label>
                </div>

                <div *ngIf="!isDisabled()" class="col-md-6 pt-2 ">
                  <div>
                    <label> Refund Applicable<span class="text-danger">*</span></label>
                  </div>

                  <div class="form-check form-check-inline col-3">
                    <input class="form-check-input border border-dark" type="radio" name="proceedWithRefund"
                      id="proceedWithRefundYes" [value]=true formControlName="proceedWithRefund"  />
                    <label class="form-check-label" for="proceedWithRefundYes">
                      Yes</label>
                  </div>
                  <div class="form-check form-check-inline col-3">
                    <input class="form-check-input border border-dark" type="radio" [value]=false name="proceedWithRefund"
                      id="proceedWithRefundNo" formControlName="proceedWithRefund" />
                    <label class="form-check-label" for="proceedWithRefundNo">No</label>
                  </div>


                </div>


                <div *ngIf="isDisabled()" class="col-md-6 pt-2 ">
                  <div>
                    <label> Refund Applicable<span class="text-danger">*</span></label>
                  </div>

                  <div class="form-check form-check-inline col-3">
                    <input disabled class="form-check-input border border-dark" type="radio" name="proceedWithRefund"
                      id="proceedWithRefundYes" [value]=true formControlName="proceedWithRefund"  />
                    <label class="form-check-label" for="proceedWithRefundYes">
                      Yes</label>
                  </div>
                  <div class="form-check form-check-inline col-3">
                    <input disabled class="form-check-input border border-dark" type="radio" [value]=false name="proceedWithRefund"
                      id="proceedWithRefundNo" formControlName="proceedWithRefund" />
                    <label class="form-check-label" for="proceedWithRefundNo">No</label>
                  </div>


                </div>



                <div class="col-md-6 pt-2 ">
                  <label>{{lang.Refund_Applicable}}:
                      <input *ngIf="!isDisabled()" type="text" class="form-control border border-dark"
                      placeholder="Please enter actual refund amount" formControlName="refundAmount" />

                      <input *ngIf="isDisabled()" disabled type="text" class="form-control border border-dark"
                      placeholder="Please enter actual refund amount" formControlName="refundAmount" />
                    </label>
                </div>

                <!-- <div class="col-md-6 pt-2 ">
                  <label>Refund Applicabsle:
                    {{staxbillDetails?.refundApplicable==false?' No':'Yes'}}</label>
              </div> -->
              <div class="col-md-6 pt-2">
                <label>{{lang.Payment_Method}}:
                  {{terminateMemberDetails?.paymentMethod}}</label>
              </div>
              <!-- <div class="col-md-6 pt-2 ">
                  <label>{{lang.Refund_Actual_Amount}}:
                    {{staxbillDetails?.refundAmount=='NA'?"N/A":'$ ' +staxbillDetails?.refundAmount}}</label>
                </div> -->
              <div class="col-md-6 pt-2 ">
                <label>{{lang.Refund_Based_on_Payments}}:
                  $ {{terminateMemberDetails?.refundAmountbasedOnPayments}}</label>
              </div>

            </div>
          </div>

          <div class="row  px-2 mt-2" *ngIf="terminateMemberDetails?.invoiceAndRefunds.length>0">

            <table align="left">
              <tr>
                <th class="my-auto" style="background: #5d7c9b !important; ">{{lang.Invoice_Id}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Invoice_Number}}</th>
                <th class="text-center" style="background: #5d7c9b !important; ">{{lang.Amount}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Date}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Payment_Status}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Refund_Applicable}}</th>
              </tr>
              <tbody>
                <tr *ngFor="let invoice of terminateMemberDetails.invoiceAndRefunds">
                  <td>{{invoice.id}}</td>
                  <td>{{invoice.invoiceNumber}}</td>
                  <td class="text-center">$ {{invoice.invoiceAmount | number : "1.2-2"}}</td>
                  <td>{{invoice.postedTimestamp|date: 'MM-dd-YYYY'}}</td>
                  <td>{{invoice?.paymentStatus}}</td>
                  <td>{{invoice?.refundApplicable ===false?'No':'Yes'}}</td>
                </tr>
              </tbody>
            </table>

          </div>


          <!-- table -->
          <div class="row px-2 mt-2"
            *ngIf="terminateMemberDetails?.serviceType.length>0 && terminateMemberDetails?.terminationsProvisioning.length>0">
            <table align="left" style="background: #5d7c9b !important; ">
              <tr>
                <th class="my-auto" style="background: #5d7c9b !important; ">{{lang.Service}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Name}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Policy}}</th>
                <th style="width:175px ;background: #5d7c9b !important;">{{lang.Effective_Termination_Date}}</th>
                <th style="width:100px ;background: #5d7c9b !important;">{{lang.Membership_Id}}</th>
                <th style="width:200px ;background: #5d7c9b !important; ">{{lang.Action}}</th>
              </tr>
              <tbody>

                <tr class=" my-auto bg-white" *ngFor="let item of terminationsProvisioning ; let index=index">
                  <td>{{item?.serviceType}}</td>
                  <td>{{item?.service}}</td>
                  <td>{{item?.policy}}</td>
                  <td>{{item?.date}}<br><small>{{item.description}}</small></td>
                  <td>{{item?.membershipId}}</td>
                  <td>

                    <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showEquitable">
                      <div class="col-12">
                        <label for=""> {{lang.Proceed_With_Equitable}}<span class="text-danger">*</span></label>
                      </div>

                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" name="proceedWithEquitable"
                          id="proceedWithEquitableYes" [value]=true formControlName="proceedWithEquitable" />
                        <label class="form-check-label" for="proceedWithEquitableYes">
                          {{lang.Yes}}</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" [value]=false
                          name="proceedWithEquitable" id="proceedWithEquitableNo"
                          formControlName="proceedWithEquitable" />
                        <label class="form-check-label" for="proceedWithEquitableNo">{{lang.No}}</label>
                      </div>

                    </div>

                    <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showSmartchoice">
                      <div class="col-12">
                        <label for=""> {{lang.Proceed_With_Smartchoice}}<span class="text-danger">*</span></label>
                      </div>

                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" name="proceedWithSmartchoice"
                          id="proceedWithSmartchoiceYes" [value]=true formControlName="proceedWithSmartchoice" />
                        <label class="form-check-label" for="proceedWithSmartchoiceYes">
                          {{lang.Yes}}</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" [value]=false
                          name="proceedWithSmartchoice" id="proceedWithSmartchoiceNo"
                          formControlName="proceedWithSmartchoice" />
                        <label class="form-check-label" for="proceedWithSmartchoiceNo">{{lang.No}}</label>
                      </div>

                    </div>
                    <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showGreenshield">
                      <div class="col-12">
                        <label for=""> {{lang.Proceed_With_Greenshield}}<span class="text-danger">*</span></label>
                      </div>

                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" name="proceedWithGreenshield"
                          id="proceedWithGreenshieldYes" [value]=true [disabled]="!item?.membershipId"
                          formControlName="proceedWithGreenshield" />
                        <label class="form-check-label" for="proceedWithGreenshieldYes">
                          {{lang.Yes}}</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" [value]=false
                          name="proceedWithGreenshield" [disabled]="!item?.membershipId" id="proceedWithGreenshieldNo"
                          formControlName="proceedWithGreenshield" />
                        <label class="form-check-label" for="proceedWithGreenshieldNo">{{lang.No}}</label>
                      </div>

                    </div>
                    <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showPHR">
                      <div class="col-12">
                        <label for=""> {{lang.Proceed_With_PHR}}<span class="text-danger">*</span></label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" name="proceedWithPHR"
                          id="proceedWithPHRYes" [value]=true [disabled]="!item?.membershipId"
                          formControlName="proceedWithPHR" />
                        <label class="form-check-label" for="proceedWithPHRYes">
                          {{lang.Yes}}</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" [value]=false
                          name="proceedWithPHR" [disabled]="!item?.membershipId" id="proceedWithPHRNo"
                          formControlName="proceedWithPHR" />
                        <label class="form-check-label" for="proceedWithPHRNo">{{lang.No}}</label>
                      </div>

                    </div>
                  </td>

                </tr>

              </tbody>

            </table>

          </div>

          <div class="row" *ngIf="terminateReasonsApplicable">
            <div class="col-12 col-md-6 pb-2">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Reason}}</label>

                <select class="form-control select2" id="parentidrole" placeholder="Select" formControlName="reason"
                  data-live-search="true">
                  <option value="" label="" disabled>{{lang.Select}}</option>
                  <option value="" *ngFor="let reson of terminateReasonsWithKeys" [value]="reson.key">
                    {{reson.display}}</option>
                </select>

              </div>
            </div>
          </div>

        </form>

      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="closeModelPopup('showTerminateMemberDetails')">
          {{lang.Cancel}}
        </button>
        <button class="text-end" type="submit" class="btn btn-primary personalinfobutton"
          (click)="submitterminationEnd()">
          {{lang.Terminate}}&nbsp;&nbsp;
        </button>

      </div>
    </div>
  </div>
</div>

<div class="modal" id="showCorporatelist" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered" id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <span class="modal-title"><b>Corporate List</b></span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="model-body" style="padding-left:5px">
        <form [formGroup]="corporateList">
          <div class="row">
            <div class="col-md-6">
              <label>Coporate Name<span style="color: red">*</span></label>
              <select class="form-control" id="corporateName" formControlName="corporateName" placeholder="corporate"
                (change)="getCorporateDetails($event)">
                <option value="">Select</option>
                <option *ngFor="let item of clientList" [value]="item.name">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
          <!-- <div class="row" *ngIf="selectedItem">
          <div class="col-md-12">
            <label>Coporate Details<span style="color: red">*</span></label>
            <table>
              <th>Name</th>
              <th>Parent</th>
              <th>Employee Profile</th>
              <th>Plan Headcount</th>
            </table>
            <tbody>
              <tr>
                <td>{{selectedItem?.name}}</td>
                <td>{{selectedItem?.parentName}}</td>
                <td>{{selectedItem?.customersCount}}</td>
                <td>{{selectedItem?.bulkEmployeeCount}}</td>
              </tr>
            </tbody>

          </div>
        </div> -->
        </form>
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
        <button class="text-end" type="submit" class="btn btn-primary personalinfobutton"
          [disabled]="corporateList.invalid" (click)="getCorporateData()">
          {{lang.Submit}}&nbsp;&nbsp;
        </button>

      </div>
    </div>
  </div>
</div>

<!-- Choose Effective Date -->
<div class="modal" id="showeffectiveDate" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered" id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor" style="height: 40px;">
        <span class="modal-title">Effective
          Date&nbsp;&nbsp;<b></b></span>
        <!-- <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i> -->
      </div>
      <div class="model-body">
        <form class="onbordingform" [formGroup]="effectiveDateForm">
          <div class="row">
            <div class="col-12 col-md-7">
              <div class="form-group">
                <label for="Corporation" class="Corporation">Please choose Effective Date</label>
                <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field"
                  formControlName="effectiveDate" [minDate]="minDate" bsDatepicker
                  [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
                <div class="help-block text-danger" *ngIf="effectiveDateForm.get('effectiveDate')?.touched ">
                  <div *ngIf="effectiveDateForm.get('effectiveDate')?.hasError('required') ||
                  (effectiveDateForm.get('effectiveDate')?.hasError('required'))"> {{lang.Please_Select_Date}}</div>

                </div>
              </div>


              <!-- <p *ngIf="role==='ADMINISTRATOR'" style="font-size:10px">{{lang.Plan_enrollment_date_is}}-{{enroll
                |date:'MM-dd-YYYY'}}<br>{{note}}
              </p> -->

            </div>
          </div>
        </form>

      </div>
      <div class="modal-footer py-2">
        <!-- <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button> -->
        <button class="text-end" type="submit" class="btn btn-primary personalinfobutton"
          [disabled]="effectiveDateForm.invalid" (click)="submiteffectiveDate()">
          {{lang.Submit}}&nbsp;&nbsp;
        </button>

      </div>
    </div>
  </div>
</div>

<!-- ADD NEW PLANS TO GIG MEMBER WHEN CONVERTING FROM GIG TO CORP -->
<div class="modal" id="showPlansForEmployee" aria-labelledby="exampleModalLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-lg modal-dialog-centered " id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Plans</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">


        <div class="input-wrapper row border border-dark mx-1 mt-2 linescrollbar"
          style="font-size: 12px; width:100%;max-height:350px;overflow-y: scroll;">
          <div *ngFor="let package of mainarrayFinal;let a =index" class="plansscreen">

            <span style="color:black">{{package?.name}}</span>

            <div class="wraptext">
              <div *ngFor="let group of package.groups;let k=index">
                <div *ngFor="let plan of group.plans; let i = index">
                  <div *ngIf="plan.insuranceType!='LIFE'">
                    <div class="package-groups col-md-4" *ngFor="let product of plan.productAddonssNames; let r = index"
                      title=""
                      [style.background-color]="plan.isBundle==false?plan.productAddonss[product][0]?.planlevel.backgroundColor:group.backgroundColor||'#5E172E'">

                      <span class="plantitle"> <span style="color: white"
                          *ngIf="group.categorization.paidByCompany==1">{{lang?.Company_Paid}}</span>
                        <span style=" color: white"
                          *ngIf="group.categorization.coveredByCompany==1">{{lang?.Upgrade_To}}</span>
                        <span style=" color: white"
                          *ngIf="group.categorization.paidByEmployee==1">{{lang?.Voluntary_Opt_In}}</span><br>
                        <span style="color:white">{{product}}</span></span>

                      <div class="plancoverage ">
                        <div class="plansCoverageDetails row col-12"
                          *ngFor="let coverage of  plan.productAddonss[product]; let k = index">

                          <div class="col-4" *ngIf="coverage?.display??false">
                            <span class="overflow-ellipsis" style="float: left; color: white;font-size:14px"
                              title={{coverage.planCoverageUI}}>

                              <input type="checkbox"
                                id="plancheck{{plan.isBundle?plan.id:plan.productAddonss[product][k].planlevel.id }}"
                                class="plancheckbox{{ package.id }} plancv newPlan{{plan.id}} {{group.categorization.paidByCompany==1?'cp_plan':group.categorization.coveredByCompany==1?'cc_plan':'ep_plan'}} coverage{{coverage.planCoverageUI | uppercase}}"
                                attr.data="{{ package.name }}##{{ group.name }}##{{
                         plan.planCoverage
                       }}##{{plan.productAddonss[product][k].calculatedTax.price}}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                         plan.frqMonthly
                       }}##{{ package.optIn }}##{{
                         group.disallowedPlanLevels
                       }}##{{ group.parentId }}##{{ group.id }}##{{
                         plan.name
                       }}##{{ plan.planLevel }}##{{ plan.packageId }}##0##{{plan.planOptions}}##{{plan.productAddonss[product][k].id}}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}##{{plan.products && plan.products[k].upgradeCalculation?true:false}}"
                                (change)="
                                                                 onCheckboxChange(
                           $event,
                           package.allowMultiple,
                           plan.productAddonss[product][k].plan_level.disallowedPlanLevels,
                           plan.planOptions,
                           group.parentId,
                           package.name,
                           group.name,
                           plan.planCoverage,
                           0,
                           0,
                           0,
                           0,
                           $event,
                           i,
                           j,
                           k,
                           plan,
                           plan.productAddonss[product][k],package,group
                         )
                                                              ">

                              {{coverage.planCoverageUI}}</span><span class="clearfix"></span>
                          </div>
                          <div class="col-8" *ngIf="coverage?.display??false">
                            <span class="overflow-ellipsis2" style="float: right; color: white"
                              *ngIf="group.categorization.paidByCompany==1">
                              <span *ngIf="plan.products;else noProducts">
                                <span *ngIf="plan.products[k] && plan.products[k].upgradeCalculation;else block1">
                                  <span
                                    *ngIf="plan.products[k].upgradeCalculation.deltaplanPrice<=0;else deltaplanPriceCheck">
                                    <span style="font-size: 14px;">{{lang.Employee_pays}} {{
                                      currencySymbol}}0.00<small>*</small></span>
                                  </span>
                                  <ng-template #deltaplanPriceCheck>
                                    <span
                                      style="font-size: 14px;float:right">{{lang.Employee_pays_through_payroll_deduction}}
                                      {{
                                      currencySymbol}}{{plan.products[k].upgradeCalculation.deltaplanPrice | number:
                                      "1.2-2"}}<small>*</small></span>
                                  </ng-template>
                                </span>
                                <ng-template #block1>
                                  <span *ngIf="plan.upgradeCalculation;else block2">
                                    <span *ngIf="plan.upgradeCalculation.deltaplanPrice<=0;else noDeltaplanPrice">
                                      <span style="font-size: 14px;">{{lang.Employee_pays}} {{
                                        currencySymbol}}0.00<small>*</small></span>

                                    </span>
                                    <ng-template #noDeltaplanPrice>
                                      <span
                                        style="font-size: 14px;float:right">{{lang.Employee_pays_through_payroll_deduction}}
                                        {{
                                        currencySymbol}}{{plan.upgradeCalculation.deltaplanPrice | number:
                                        "1.2-2"}}<small>*</small></span>
                                    </ng-template>
                                  </span>
                                </ng-template>
                                <ng-template #block2>
                                  <span>
                                    <span style="font-size: 14px;">{{lang.Employee_pays}} {{
                                      currencySymbol}}0.00<small>*</small></span>

                                  </span>

                                </ng-template>


                              </span>
                              <ng-template #noProducts>
                                <span style="font-size: 14px;">{{lang.Employee_pays}} {{
                                  currencySymbol}}0.00<small>*</small></span>

                              </ng-template>
                            </span>

                            <span class="overflow-ellipsis2" style="float: right; color: white"
                              *ngIf="group.categorization.coveredByCompany==1">
                              <span style="float:right;color:white;font-size: 14px;">{{
                                currencySymbol}}{{(plan.products?plan.products[k].upgradeCalculation.deltaplanPrice:plan.upgradeCalculation.deltaplanPrice)
                                | number:
                                "1.2-2"}}<small>*</small></span></span>
                            <span class="overflow-ellipsis2" style="float: right; color: white"
                              *ngIf="group.categorization.paidByEmployee==1"><span
                                style="float:right;color:white;font-size: 14px;">{{
                                currencySymbol}}{{coverage.price |
                                number: "1.2-2" }}<small>*</small></span></span>
                          </div>
                        </div>
                        <div class="taxes">
                          <span *ngIf="group.categorization.paidByCompany==1">*{{lang?.Employee_pays}}</span>
                          <span
                            *ngIf="group.categorization.coveredByCompany==1">*{{lang?.Employee_pays_through_payroll_deduction}}</span>
                          <span *ngIf="group.categorization.paidByEmployee==1"
                            class="my-2">*{{lang?.Employee_pays_through_CC_PAD}}</span>

                        </div>
                      </div>


                      <!-- Member -->





                    </div>
                  </div>



                </div>
              </div>
            </div>


          </div>

        </div>
        <!-- <div *ngIf="plansError" class="text-danger text-end" style="font-size:12px">
            {{lang.Please_select_atleast_one_plan}}
          </div> -->

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="newplansadded()">
          {{lang.Proceed}}
        </button>

      </div>
    </div>
  </div>
</div>

<div class="modal" id="showaddMemberConfiguration" aria-labelledby="exampleModalLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-lg modal-dialog-centered " id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor" style="height: 40px;">
        <span class="modal-title">Add this GIG Member with which plans?&nbsp;&nbsp;<b></b></span>
        <!-- <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i> -->
      </div>
      <!-- <div class="modal-header">
        <h6 class="modal-title">Add this GIG Member with which plans?</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div> -->
      <div class="modal-body">


        <div class="input-wrapper row border border-dark mx-1 mt-2 linescrollbar"
          style="font-size: 12px; width:100%;max-height:350px;overflow-y: scroll;">

          <h6><strong>Existing Plans:</strong></h6>
          <p>Example:Plans with the same pricing in both Corporate and GIG:(Private Health,Protect,High Cost
            Drugs,Wellness,..etc)</p>

          <p>Plans already using group pricing:(Classic with Group Pricing,All-in)</p>
          <div *ngIf="MemberDetails?.customerPlans && MemberDetails?.customerPlans.length>0">
            <p>
              <strong>Below are the Existing GIG plans for Member:</strong>
            </p>
            <table>
              <tr>
                <th>Plan Name</th>
                <th>Coverage</th>
              </tr>
              <tr *ngFor="let item of MemberDetails?.customerPlans">
                <td>{{item.name}}</td>
                <td>{{item.coverage1}}</td>
              </tr>
            </table>
          </div>


          <hr>

          <h6><strong>Conversion Process:</strong></h6>
          <p>Convert all existing plans to Group Pricing and add new subscriptions.</p>
          <p><strong>Example:</strong> At least one plan will have different GIG and Group Pricing.(<strong>Classic with
              GIG Pricing</strong>)</p>


          <hr>

          <h6><strong>New Plans:</strong></h6>
          <p>Cancel all current plans and add new plans according to the corporate profile.</p>
          <p><strong>Note:</strong> Please check the next screen for updated plan details.</p>


        </div>


      </div>
      <div class="modal-footer d-flex justify-content-end">
        <button type="button" class="btn btn-outline-primary mx-2" (click)="ExistingPlans()">
          Existing
        </button>
        <button type="button" class="btn btn-outline-warning mx-2" (click)="ConvertPlans()">
          Convert
        </button>
        <button type="button" class="btn btn-outline-danger mx-2" (click)="Newplans()">
          New
        </button>
      </div>

    </div>
  </div>
</div>
<app-confirmation-dialog [message]="message" [languageData]="languageData" *ngIf="languageData">
</app-confirmation-dialog>
<app-activity-log></app-activity-log>